<template>
  <BittsCallout
    v-if="showCallout"
    :title="title"
    :subtitle="subtitle"
    data-testid="onboarding-callout"
    size="small"
    type="info"
  >
    <template #left-item>
      <BittsSvg svg="pamFace" class="h-40 w-40 mr-16" />
    </template>
    <template #right-item>
      <BittsButton
        variant="outline"
        type="primary"
        :left-icon="['fak', 'play']"
        text="Watch a video"
        class="ml-auto"
        size="small"
        @click="routeToVideo"
      />
      <BittsButton
        :center-icon="['fak', 'x']"
        aria-label="Close"
        size="x-small"
        class="ml-16"
        type="neutral"
        variant="ghost"
        @click="handleCloseCallout"
      />
    </template>
  </BittsCallout>
</template>

<script setup>
import { BittsButton, BittsCallout, BittsSvg } from '@crossbeam/bitts';

import { computed, ref } from 'vue';

import { ls } from '@/local_storage';

const props = defineProps({
  kind: {
    type: String,
    required: true,
    validator(val) {
      return ['data_sources', 'populations', 'offline_partner_data'].includes(
        val,
      );
    },
  },
});
const DATA_SOURCES = 'data_sources';
const POPS = 'populations';
const OFFLINE_PARTNER_DATA = 'offline_partner_data';

/* Blue Onboarding Helper Callout */
const calloutStates = ref(
  ls.onboardingCallouts.get() || {
    data_sources: true,
    populations: true,
    offline_partner_data: true,
  },
);
const showCallout = computed(() => calloutStates.value[props.kind]);

const TITLE_MAP = {
  [DATA_SOURCES]: 'Data sources are how you feed data into Crossbeam',
  [POPS]:
    'Populations are how you segment your data to share strategic accounts with partners',
  [OFFLINE_PARTNER_DATA]: 'You fully control the data for offline partners',
};

const DESCRIPTION_MAP = {
  [DATA_SOURCES]:
    'This is all the data valuable to you, not what is shared with partners. We will segment & share with partners later.',
  [POPS]:
    'You have full control over how these segments are defined and shared with each partner',
  [OFFLINE_PARTNER_DATA]:
    'Upload data on your partners behalf, it will only be shared with members of your team',
};

const VIDEO_MAP = {
  [DATA_SOURCES]:
    'https://www.loom.com/share/2d2a80ccb68e465d8be14f442859badb?sid=f90c7ab1-a75b-4f84-9c5c-5cf0bddfc6db',
  [POPS]:
    'https://www.loom.com/share/a31fee1ce85b481690d528df160739ec?sid=a91cddd3-38fb-44f7-ab54-6b626986110f',
  [OFFLINE_PARTNER_DATA]:
    'https://www.loom.com/share/e1b3ef1408764a2b9597b48f7ce60185?sid=def23a35-1e6f-4e7d-8ef4-1c7a7a1c9fb6',
};

const title = computed(() => TITLE_MAP[props.kind]);
const subtitle = computed(() => DESCRIPTION_MAP[props.kind]);

function routeToVideo() {
  const video = VIDEO_MAP[props.kind];
  window.open(video, '_blank');
}

function handleCloseCallout() {
  const newState = { ...calloutStates.value, [props.kind]: false };
  ls.onboardingCallouts.set(newState);
  calloutStates.value = newState;
}
</script>
